import type { HTMLAttributes, ReactNode } from 'react';
import { useTheme } from '../../theme';

export interface StudentCourseCarouselItemProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/** Slot com largura mínima e snap horizontal para itens do carrossel de cursos. */
export function StudentCourseCarouselItem({
  children,
  style,
  ...rest
}: StudentCourseCarouselItemProps) {
  const theme = useTheme();
  const L = theme.layout.studentDashboard;

  return (
    <div
      style={{
        flex: `0 0 calc((100% - ${theme.spacing.lg}) / 2)`,
        maxWidth: `calc((100% - ${theme.spacing.lg}) / 2)`,
        minWidth: L.courseCardSlotMinWidth,
        scrollSnapAlign: 'start',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
